import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './ChatTriggerButton.scss';

/**
 * ChatbotButton component that serves as a floating button to trigger the chatbot
 */
function ChatTriggerButton({ onClick }) {
  const { t } = useTranslation(['chatbot']);

  return (
    <button
      type="button"
      className="chatbot-button"
      onClick={onClick}
      aria-label={t('Open chat assistant')}
      style={{ border: 0, background: 'transparent', cursor: 'pointer' }}
    >
      <div className="chatbot-button__image" />
    </button>
  );
}

ChatTriggerButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

// Use React.memo to prevent unnecessary re-renders
export default React.memo(ChatTriggerButton);
